import React from 'react';
import LegalPageShell from '../components/LegalPageShell';

const sections = [
  {
    num: 1,
    title: 'Overview',
    content: (
      <p>
        Taraanaya sells <strong>digital subscription services and pre-paid digital credits</strong>.
        Because content is delivered immediately upon successful payment, refunds are governed by the
        rules in this policy. By making a purchase, you agree to these terms.
      </p>
    ),
  },
  {
    num: 2,
    title: 'Subscription Plans (Starter / Premium / Ultimate)',
    content: (
      <>
        <p>Subscription plans are 30-day digital licences priced as below (all prices in INR, inclusive of 18% GST &mdash; SAC 998599).</p>
        <table>
          <tbody>
            <tr><th>Plan</th><th>Price</th><th>Validity</th></tr>
            <tr><td>Starter</td><td>&#8377;199</td><td>30 days</td></tr>
            <tr><td>Premium</td><td>&#8377;599</td><td>30 days</td></tr>
            <tr><td>Ultimate</td><td>&#8377;999</td><td>30 days</td></tr>
          </tbody>
        </table>
        <ul>
          <li><strong>7-day full refund</strong> if you have <em>not</em> streamed any premium personalised content (Past Story video, Future Reels, Domain Insights). Email <a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a> from your registered address with the order ID.</li>
          <li>Once any premium video / narration has been streamed, the subscription is deemed delivered and is non-refundable.</li>
          <li>Plan upgrades within an active subscription (e.g. Starter &rarr; Premium) are treated as top-ups; the original plan amount is not refunded.</li>
          <li>Auto-renewals (Google Play / Apple) can be cancelled in the platform&rsquo;s subscription settings at least 24 hours before the next billing cycle. The current cycle remains active until expiry.</li>
        </ul>
      </>
    ),
  },
  {
    num: 3,
    title: 'Sage AI Question Credit Packs',
    content: (
      <>
        <table>
          <tbody>
            <tr><th>Pack</th><th>Price</th><th>Credits</th></tr>
            <tr><td>Small</td><td>&#8377;199</td><td>300 credits</td></tr>
            <tr><td>Medium</td><td>&#8377;599</td><td>1,000 credits</td></tr>
            <tr><td>Large</td><td>&#8377;999</td><td>1,500 credits</td></tr>
          </tbody>
        </table>
        <ul>
          <li>Once credits are credited to your wallet they are <strong>non-refundable</strong>.</li>
          <li>If your money was debited but credits were <em>not</em> added because of a technical failure, we issue a full refund within 7 working days. Email <a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a> with the bank/UPI transaction ID.</li>
          <li>Unused credits are non-transferable and have no monetary value outside the platform.</li>
        </ul>
      </>
    ),
  },
  {
    num: 4,
    title: 'Refund Process',
    content: (
      <ol style={{ paddingLeft: 22, marginTop: 6 }}>
        <li style={{ marginBottom: 6 }}>Email <a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a> with the order ID, payment ID, and the reason for the refund request.</li>
        <li style={{ marginBottom: 6 }}>We acknowledge within 48 working hours and resolve within 7 working days.</li>
        <li style={{ marginBottom: 6 }}>Approved refunds are credited to the original payment instrument (UPI / card / wallet / Google Play / Apple) within 5&ndash;10 working days, subject to your bank/PG cycle.</li>
        <li>For Google Play and Apple App Store purchases, refunds may also be requested directly via the respective store as per their published policies.</li>
      </ol>
    ),
  },
  {
    num: 5,
    title: 'Cancellation',
    content: (
      <>
        <p>You may cancel auto-renewing subscriptions at any time:</p>
        <ul>
          <li><strong>Web (Razorpay):</strong> Subscriptions are non-auto-renewing &mdash; no cancellation needed; simply do not renew.</li>
          <li><strong>Android (Google Play):</strong> Open <em>Google Play &rarr; Profile &rarr; Payments &amp; subscriptions &rarr; Subscriptions &rarr; Taraanaya</em> &rarr; Cancel.</li>
          <li><strong>iOS (Apple App Store):</strong> Open <em>Settings &rarr; Apple ID &rarr; Subscriptions &rarr; Taraanaya</em> &rarr; Cancel.</li>
        </ul>
        <p>Cancellation stops future renewals; the current paid period continues until expiry.</p>
      </>
    ),
  },
  {
    num: 6,
    title: 'Non-Refundable Items',
    content: (
      <ul>
        <li>Subscription content already streamed.</li>
        <li>Sage AI credits already credited to your wallet (whether used or not).</li>
        <li>Plans purchased more than 7 days ago.</li>
        <li>Refund requests received after the auto-renew billing cycle has begun (cancel before next renewal to avoid).</li>
      </ul>
    ),
  },
  {
    num: 7,
    title: 'Disputes &amp; Grievance',
    content: (
      <p>
        For any refund-related grievance, please first email
        <a href="mailto:taraanaya@taraanaya.ai"> taraanaya@taraanaya.ai</a>. If the issue is not
        resolved within 30 days, you may escalate to our Grievance Officer:
        <strong> Mr. Mandeep Singh Chadha</strong>, at the same email or at the registered office
        address. This policy is governed by the laws of India; courts at Gautam Buddha Nagar, Uttar
        Pradesh have exclusive jurisdiction.
      </p>
    ),
  },
];

export default function RefundPolicy() {
  return (
    <LegalPageShell
      title="Refund &amp; Cancellation Policy"
      subtitle="Refund rules for digital subscriptions and pre-paid credits."
      lastUpdated="20 September 2026"
      sections={sections}
      dataTestId="refund-policy-page"
    />
  );
}
